"use strict";
module.exports = {
    'name': 'Italian',
    'code': 'it',
    'greeting': 'ciao',
    'drag & drop': 'trascina e rilascia',
    'or click here to browse': 'o clicca qui per navigare',
    'follow': 'Seguir',
    'following': 'Siguiente',
    'explore tracks': 'Esplora le tracce',
    'create your own': 'Crea il tuo',
};
